import type { Skill } from '../skillsData';

export const cryptoskillTradingDData: Skill[] = [
  {
    id: 'polybot-accounts',
    name: 'polybot-accounts',
    author: 'Polybot',
    authorHandle: '@polybot_ai',
    tag: 'Skill',
    category: 'trading',
    description: 'Polybot multi-account management. Unified trading across multiple exchange accounts, sub-account allocation, and cross-account strategy deployment.',
    downloads: 6200,
    stars: 440,
    installCommand: '> install the polybot-accounts skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/polybot-accounts',
    usageExample: '> manage multiple accounts\n> allocate sub-accounts\n> deploy cross-account strategy',
    detailedDescription: 'Polybot multi-account management system for institutional traders. Manages trading across multiple exchange accounts from a single interface, allocates capital between sub-accounts based on strategy requirements, and deploys synchronized strategies across accounts with unified PnL tracking and risk monitoring.',
  },
  {
    id: 'polybot-copy',
    name: 'polybot-copy',
    author: 'Polybot',
    authorHandle: '@polybot_ai',
    tag: 'Skill',
    category: 'trading',
    description: 'Polybot copy trading engine. Mirror trades from signal providers, manage copy ratios, and filter providers by risk-adjusted performance metrics.',
    downloads: 7800,
    stars: 560,
    installCommand: '> install the polybot-copy skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/polybot-copy',
    usageExample: '> copy signal provider\n> set copy ratio\n> filter by performance',
    detailedDescription: 'Polybot copy trading engine for social trading automation. Mirrors trades from verified signal providers with configurable copy ratios and position sizing, filters providers by risk-adjusted performance metrics including Sharpe ratio, maximum drawdown, and win rate, and manages copy positions with independent stop-loss and take-profit settings.',
  },
  {
    id: 'polybot-discover',
    name: 'polybot-discover',
    author: 'Polybot',
    authorHandle: '@polybot_ai',
    tag: 'Skill',
    category: 'trading',
    description: 'Polybot opportunity discovery. Scan emerging tokens, detect new liquidity pools, and identify early-stage trading opportunities across chains.',
    downloads: 9200,
    stars: 660,
    installCommand: '> install the polybot-discover skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/polybot-discover',
    usageExample: '> scan emerging tokens\n> detect new liquidity pools\n> identify early opportunities',
    detailedDescription: 'Polybot opportunity discovery scanner. Continuously scans blockchain data for emerging tokens and new liquidity pool creations, detects early-stage trading opportunities through volume anomaly detection and social sentiment acceleration, and provides ranked opportunity lists with risk assessments and entry timing recommendations.',
  },
  {
    id: 'purobot-trader',
    name: 'purobot-trader',
    author: 'Purobot',
    authorHandle: '@purobot',
    tag: 'Skill',
    category: 'trading',
    description: 'Purobot automated trader. Pure execution-focused trading bot with minimal overhead, fast order placement, and streamlined position management.',
    downloads: 4800,
    stars: 340,
    installCommand: '> install the purobot-trader skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/purobot-trader',
    usageExample: '> execute fast order\n> manage positions simply\n> minimal overhead trading',
    detailedDescription: 'Purobot minimalist automated trader designed for pure execution speed. Features minimal computational overhead for ultra-fast order placement, streamlined position management with essential controls only, and efficient memory footprint for running on resource-constrained devices while maintaining reliable trade execution.',
  },
  {
    id: 'pumpfun-trader',
    name: 'pumpfun-trader',
    author: 'PumpFun',
    authorHandle: '@pumpfun',
    tag: 'Skill',
    category: 'trading',
    description: 'PumpFun trading specialist. Automated Pump.fun integration, bonding curve trading, graduation detection, and post-graduation Raydium strategies.',
    downloads: 16800,
    stars: 1200,
    installCommand: '> install the pumpfun-trader skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/pumpfun-trader',
    usageExample: '> trade on Pump.fun\n> detect graduation\n> execute Raydium strategy',
    detailedDescription: 'PumpFun specialized trading agent for Solana Pump.fun platform. Automates bonding curve trading with optimal entry and exit timing, detects graduation probability based on market cap progression and holder count, and seamlessly transitions strategies to post-graduation Raydium trading with liquidity pool analysis and volatility-adjusted position sizing.',
  },
  {
    id: 'quantrum-ai',
    name: 'quantrum-ai',
    author: 'Quantrum',
    authorHandle: '@quantrum',
    tag: 'Skill',
    category: 'trading',
    description: 'Quantrum AI trading core. Quantum-inspired algorithms, multi-dimensional market analysis, and advanced pattern recognition for crypto trading.',
    downloads: 7600,
    stars: 540,
    installCommand: '> install the quantrum-ai skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/quantrum-ai',
    usageExample: '> run quantum-inspired algo\n> analyze multi-dimensional market\n> recognize advanced pattern',
    detailedDescription: 'Quantrum AI core trading engine inspired by quantum computing algorithms. Uses multi-dimensional market state analysis beyond traditional technical indicators, implements advanced pattern recognition through tensor decomposition and manifold learning, and generates trading signals from complex market geometry rather than linear indicators.',
  },
  {
    id: 'quantrum-heyanon',
    name: 'quantrum-heyanon',
    author: 'Quantrum',
    authorHandle: '@quantrum',
    tag: 'Skill',
    category: 'trading',
    description: 'Quantrum HeyAnon integration. Natural language interface for Quantrum trading, conversational strategy deployment, and voice-activated trade execution.',
    downloads: 4200,
    stars: 300,
    installCommand: '> install the quantrum-heyanon skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/quantrum-heyanon',
    usageExample: '> trade by natural language\n> deploy strategy conversationally\n> activate voice command',
    detailedDescription: 'Quantrum HeyAnon natural language trading integration. Enables conversational strategy deployment through natural language commands, supports voice-activated trade execution for hands-free trading, and provides plain-language explanations of complex trading decisions and market analysis through the HeyAnon AI assistant.',
  },
  {
    id: 'quantrum-swap',
    name: 'quantrum-swap',
    author: 'Quantrum',
    authorHandle: '@quantrum',
    tag: 'Skill',
    category: 'trading',
    description: 'Quantrum swap execution. Intelligent DEX swap routing, optimal path finding, and atomic multi-leg swap strategies for complex trades.',
    downloads: 6800,
    stars: 490,
    installCommand: '> install the quantrum-swap skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/quantrum-swap',
    usageExample: '> execute intelligent swap\n> find optimal route\n> run multi-leg strategy',
    detailedDescription: 'Quantrum intelligent DEX swap execution engine. Finds optimal swap routes across 40+ DEX aggregators with real-time liquidity analysis, executes atomic multi-leg swap strategies for complex token conversions, and minimizes price impact through intelligent order splitting and timing optimization.',
  },
  {
    id: 'quantrum-swap-arb',
    name: 'quantrum-swap-arb',
    author: 'Quantrum',
    authorHandle: '@quantrum',
    tag: 'Skill',
    category: 'trading',
    description: 'Quantrum swap arbitrage. Real-time DEX price discrepancy detection, flash loan arbitrage execution, and atomic swap arbitrage strategies.',
    downloads: 8200,
    stars: 590,
    installCommand: '> install the quantrum-swap-arb skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/quantrum-swap-arb',
    usageExample: '> detect price discrepancy\n> execute flash loan arb\n> run atomic swap strategy',
    detailedDescription: 'Quantrum DEX swap arbitrage specialist. Detects real-time price discrepancies across decentralized exchanges with sub-second latency, executes flash loan arbitrage transactions requiring zero upfront capital, and runs atomic swap arbitrage strategies with guaranteed execution through bundled transactions.',
  },
  {
    id: 'quantrum-swap-arbitrage',
    name: 'quantrum-swap-arbitrage',
    author: 'Quantrum',
    authorHandle: '@quantrum',
    tag: 'Skill',
    category: 'trading',
    description: 'Quantrum comprehensive swap arbitrage. Multi-DEX arbitrage scanning, cross-chain price comparison, and advanced arbitrage strategy deployment.',
    downloads: 6200,
    stars: 440,
    installCommand: '> install the quantrum-swap-arbitrage skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/quantrum-swap-arbitrage',
    usageExample: '> scan multi-DEX arb\n> compare cross-chain prices\n> deploy advanced strategy',
    detailedDescription: 'Quantrum comprehensive swap arbitrage platform. Scans for arbitrage opportunities across 50+ DEXs simultaneously with real-time price monitoring, compares prices across chains for cross-chain arbitrage identification, and deploys advanced arbitrage strategies including triangular, cross-DEX, and cross-chain with gas cost optimization.',
  },
  {
    id: 'ramius-trading-agent',
    name: 'ramius-trading-agent',
    author: 'Ramius',
    authorHandle: '@ramius_ai',
    tag: 'Skill',
    category: 'trading',
    description: 'Ramius trading agent. Institutional-grade systematic trading, portfolio optimization, and multi-factor alpha generation with rigorous risk controls.',
    downloads: 9200,
    stars: 660,
    installCommand: '> install the ramius-trading-agent skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/ramius-trading-agent',
    usageExample: '> deploy systematic strategy\n> optimize portfolio\n> generate multi-factor alpha',
    detailedDescription: 'Ramius institutional-grade systematic trading agent. Deploys multi-factor alpha generation strategies with rigorous quantitative research methodology, optimizes portfolio allocations through mean-variance optimization and risk parity approaches, and enforces strict risk controls including position limits, drawdown circuit breakers, and correlation-based exposure management.',
  },
  {
    id: 'risky-betfast',
    name: 'risky-betfast',
    author: 'BetFast',
    authorHandle: '@betfast',
    tag: 'Skill',
    category: 'trading',
    description: 'BetFast high-risk trading. Rapid high-conviction trading, aggressive position sizing, and adrenaline-fueled strategy execution for risk-tolerant traders.',
    downloads: 7200,
    stars: 520,
    installCommand: '> install the risky-betfast skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/risky-betfast',
    usageExample: '> execute rapid trade\n> size aggressively\n> run high-conviction strategy',
    detailedDescription: 'BetFast high-risk high-reward trading system for adrenaline-driven traders. Executes rapid high-conviction trades based on momentum and breakout signals, deploys aggressive position sizing with Kelly criterion variants, and runs strategies optimized for maximum upside capture with strict time-based exits to limit downside exposure.',
  },
  {
    id: 'singularity-capital',
    name: 'singularity-capital',
    author: 'Singularity',
    authorHandle: '@singularity_cap',
    tag: 'Skill',
    category: 'trading',
    description: 'Singularity Capital institutional trading. AI-driven capital allocation, macro strategy deployment, and systematic multi-asset portfolio management.',
    downloads: 8400,
    stars: 600,
    installCommand: '> install the singularity-capital skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/singularity-capital',
    usageExample: '> deploy AI allocation\n> run macro strategy\n> manage multi-asset portfolio',
    detailedDescription: 'Singularity Capital institutional-grade trading system. Deploys AI-driven capital allocation across crypto, DeFi, and derivative markets, executes macro strategy frameworks based on global liquidity cycles and regulatory trends, and manages systematic multi-asset portfolios with factor-based risk decomposition and dynamic hedging.',
  },
  {
    id: 'smith-aster-dex',
    name: 'smith-aster-dex',
    author: 'Smith Aster',
    authorHandle: '@smith_aster',
    tag: 'Skill',
    category: 'trading',
    description: 'Smith Aster DEX trading. Decentralized exchange execution, liquidity pool analysis, and AMM optimization for DeFi-native strategies.',
    downloads: 6200,
    stars: 440,
    installCommand: '> install the smith-aster-dex skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/smith-aster-dex',
    usageExample: '> execute DEX trade\n> analyze liquidity pool\n> optimize AMM strategy',
    detailedDescription: 'Smith Aster decentralized exchange trading module. Executes trades across major DEXs with optimal routing and slippage protection, analyzes liquidity pool depth and impermanent loss for LP strategies, and optimizes AMM interactions through concentrated liquidity range selection and fee tier optimization for maximum yield.',
  },
  {
    id: 'smith-aster-perps',
    name: 'smith-aster-perps',
    author: 'Smith Aster',
    authorHandle: '@smith_aster',
    tag: 'Skill',
    category: 'trading',
    description: 'Smith Aster perpetuals trading. Futures and perpetuals execution, funding rate harvesting, and basis trading across derivatives exchanges.',
    downloads: 7800,
    stars: 560,
    installCommand: '> install the smith-aster-perps skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/smith-aster-perps',
    usageExample: '> trade perpetuals\n> harvest funding rate\n> execute basis trade',
    detailedDescription: 'Smith Aster perpetuals and futures trading specialist. Executes perpetual futures trades with leverage management and liquidation protection, harvests funding rate premiums through delta-neutral strategies, and runs basis trading between spot and perpetual markets across Binance, dYdX, Hyperliquid, and other derivatives venues.',
  },
  {
    id: 'smith-aster-trader',
    name: 'smith-aster-trader',
    author: 'Smith Aster',
    authorHandle: '@smith_aster',
    tag: 'Skill',
    category: 'trading',
    description: 'Smith Aster core trader. Multi-venue automated trading, strategy orchestration, and unified performance analytics across spot and derivatives.',
    downloads: 9800,
    stars: 700,
    installCommand: '> install the smith-aster-trader skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/smith-aster-trader',
    usageExample: '> trade multi-venue\n> orchestrate strategies\n> view unified analytics',
    detailedDescription: 'Smith Aster core automated trading system. Orchestrates strategies across spot exchanges and derivatives venues simultaneously, manages unified capital allocation between venues based on opportunity detection, and provides comprehensive performance analytics with venue-level attribution, risk metrics, and Sharpe ratio by strategy.',
  },
  {
    id: 'solana-trader',
    name: 'solana-trader',
    author: 'Solana Trade',
    authorHandle: '@solana_trade',
    tag: 'Skill',
    category: 'trading',
    description: 'Solana trader. Native Solana on-chain trading, Jupiter routing, Raydium integration, and SPL token management with MEV protection.',
    downloads: 18600,
    stars: 1330,
    installCommand: '> install the solana-trader skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/solana-trader',
    usageExample: '> trade on Solana\n> route via Jupiter\n> manage SPL tokens',
    detailedDescription: 'Solana-native trading agent for on-chain execution. Integrates Jupiter aggregator for best swap routing across Solana DEXs, manages positions on Raydium and Orca liquidity pools, handles SPL token trading with automatic token account creation, and provides MEV protection through Jito bundle submission for guaranteed execution ordering.',
  },
  {
    id: 'solana-trading',
    name: 'solana-trading',
    author: 'Solana Trade',
    authorHandle: '@solana_trade',
    tag: 'Skill',
    category: 'trading',
    description: 'Solana trading suite. Comprehensive Solana DeFi trading including swaps, liquidity provision, yield farming, and governance participation.',
    downloads: 14200,
    stars: 1020,
    installCommand: '> install the solana-trading skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/solana-trading',
    usageExample: '> swap on Solana\n> provide liquidity\n> farm yield',
    detailedDescription: 'Comprehensive Solana DeFi trading suite. Execute swaps with optimal routing and minimal slippage, provide liquidity to concentrated and constant product pools with impermanent loss tracking, participate in yield farming across Solana protocols, and engage in governance voting for supported DeFi projects.',
  },
  {
    id: 'spere-defi-trader',
    name: 'spere-defi-trader',
    author: 'Spere',
    authorHandle: '@spere_defi',
    tag: 'Skill',
    category: 'trading',
    description: 'Spere DeFi trader. Cross-protocol DeFi strategy execution, yield optimization, and automated liquidity management across chains.',
    downloads: 5600,
    stars: 400,
    installCommand: '> install the spere-defi-trader skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/spere-defi-trader',
    usageExample: '> execute cross-protocol strategy\n> optimize yield\n> manage liquidity auto',
    detailedDescription: 'Spere cross-protocol DeFi trading agent. Executes strategies spanning multiple DeFi protocols simultaneously, optimizes yield by automatically shifting capital between highest-APY opportunities, and manages liquidity positions with dynamic range adjustment and automated rebalancing based on market volatility.',
  },
  {
    id: 'talos-trader',
    name: 'talos-trader',
    author: 'Talos',
    authorHandle: '@talos_trading',
    tag: 'Skill',
    category: 'trading',
    description: 'Talos institutional trading. High-performance execution algorithms, smart order routing, and real-time market analytics for professional traders.',
    downloads: 11200,
    stars: 800,
    installCommand: '> install the talos-trader skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/talos-trader',
    usageExample: '> execute algo order\n> route smartly\n> view market analytics',
    detailedDescription: 'Talos institutional-grade trading platform for professional crypto traders. Deploys high-performance execution algorithms including TWAP, VWAP, and implementation shortfall, routes orders intelligently across venues based on real-time liquidity analysis, and provides real-time market analytics with order book depth, trade flow, and volume profile visualization.',
  },
  {
    id: 'trading-analyzer',
    name: 'trading-analyzer',
    author: 'TradeAnalytics',
    authorHandle: '@tradeanalytics',
    tag: 'Skill',
    category: 'trading',
    description: 'Trading performance analyzer. Detailed trade analysis, strategy attribution, behavioral bias detection, and improvement recommendations.',
    downloads: 13200,
    stars: 940,
    installCommand: '> install the trading-analyzer skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/trading-analyzer',
    usageExample: '> analyze trade history\n> attribute strategy performance\n> detect behavioral bias',
    detailedDescription: 'Comprehensive trading performance analysis system. Analyzes detailed trade-by-trade history with entry/exit quality scoring, attributes performance to specific strategies and market conditions, detects behavioral biases including FOMO, loss aversion, and overtrading, and generates actionable improvement recommendations based on statistical analysis.',
  },
  {
    id: 'trading-macro',
    name: 'trading-macro',
    author: 'MacroTrade',
    authorHandle: '@macrotrade',
    tag: 'Skill',
    category: 'trading',
    description: 'Macro trading integration. Global macro indicator monitoring, Fed policy impact analysis, and crypto-specific macro strategy deployment.',
    downloads: 8400,
    stars: 600,
    installCommand: '> install the trading-macro skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/trading-macro',
    usageExample: '> monitor macro indicators\n> analyze Fed impact\n> deploy macro strategy',
    detailedDescription: 'Macro trading system for crypto markets. Monitors global macro indicators including interest rates, inflation, currency movements, and geopolitical events. Analyzes Federal Reserve policy impacts on crypto prices through historical correlation modeling, and deploys crypto-specific macro strategies including dollar-cost averaging during tightening and leverage reduction before significant policy announcements.',
  },
  {
    id: 'trading-signal',
    name: 'trading-signal',
    author: 'SignalHub',
    authorHandle: '@signalhub',
    tag: 'Skill',
    category: 'trading',
    description: 'Trading signal engine. Multi-source signal aggregation, confidence scoring, and automated signal execution with portfolio-aware sizing.',
    downloads: 15600,
    stars: 1120,
    installCommand: '> install the trading-signal skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/trading-signal',
    usageExample: '> aggregate signals\n> score confidence\n> execute with sizing',
    detailedDescription: 'Advanced trading signal aggregation and execution engine. Collects signals from multiple sources including technical analysis, on-chain metrics, and social sentiment, scores each signal with confidence metrics based on historical accuracy, and executes signals automatically with portfolio-aware position sizing that respects risk limits and correlation constraints.',
  },
  {
    id: 'trend-sher-ai',
    name: 'trend-sher-ai',
    author: 'TrendSher',
    authorHandle: '@trendsher',
    tag: 'Skill',
    category: 'trading',
    description: 'TrendSher AI trend detection. Advanced trend identification, trend strength measurement, and trend-following strategy automation.',
    downloads: 7200,
    stars: 520,
    installCommand: '> install the trend-sher-ai skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/trend-sher-ai',
    usageExample: '> detect market trend\n> measure trend strength\n> auto-follow trend',
    detailedDescription: 'TrendSher AI-powered trend detection and following system. Identifies market trends through multi-timeframe analysis using machine learning models trained on historical trend data, measures trend strength with proprietary momentum and volume confirmation metrics, and automates trend-following strategies with dynamic position sizing that scales with trend conviction.',
  },
  {
    id: 'unifi-trading-suite',
    name: 'unifi-trading-suite',
    author: 'Unifi',
    authorHandle: '@unifi_trade',
    tag: 'Skill',
    category: 'trading',
    description: 'Unifi trading suite. Unified multi-chain trading interface, cross-chain position management, and unified PnL tracking across all venues.',
    downloads: 9800,
    stars: 700,
    installCommand: '> install the unifi-trading-suite skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/unifi-trading-suite',
    usageExample: '> trade multi-chain\n> manage cross-chain positions\n> track unified PnL',
    detailedDescription: 'Unifi unified trading suite providing a single interface for multi-chain trading. Manage positions across Ethereum, Solana, Base, Arbitrum, and other chains from one dashboard, execute cross-chain trades through bridge-integrated routing, and track unified PnL with consolidated cost basis and performance attribution across all venues and chains.',
  },
  {
    id: 'universal-trading',
    name: 'universal-trading',
    author: 'UniversalTrade',
    authorHandle: '@universaltrade',
    tag: 'Skill',
    category: 'trading',
    description: 'Universal trading framework. Protocol-agnostic trading, universal order format, and execution across any supported exchange or DEX.',
    downloads: 11200,
    stars: 800,
    installCommand: '> install the universal-trading skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/universal-trading',
    usageExample: '> create universal order\n> execute protocol-agnostic\n> trade across any venue',
    detailedDescription: 'Universal protocol-agnostic trading framework. Provides a standardized order format that translates to any supported exchange or DEX API, enables seamless strategy portability across venues without code changes, and executes trades with venue-specific optimizations automatically applied through adapter layers.',
  },
  {
    id: 'vector-trading-ai',
    name: 'vector-trading-ai',
    author: 'VectorAI',
    authorHandle: '@vector_ai',
    tag: 'Skill',
    category: 'trading',
    description: 'Vector AI trading. Vector-based market representation, embedding similarity trading, and neural network pattern matching for signal generation.',
    downloads: 6200,
    stars: 450,
    installCommand: '> install the vector-trading-ai skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/vector-trading-ai',
    usageExample: '> create market vector\n> match embedding similarity\n> generate neural signal',
    detailedDescription: 'Vector AI trading system using advanced vector representations. Encodes market states into high-dimensional vectors for similarity-based pattern matching, uses embedding space analysis to identify historical analogs to current conditions, and generates trading signals through neural network pattern recognition trained on vectorized market data.',
  },
  {
    id: 'vital-trading',
    name: 'vital-trading',
    author: 'Vital',
    authorHandle: '@vital_trade',
    tag: 'Skill',
    category: 'trading',
    description: 'Vital trading essentials. Core trading functionality with health-check monitoring, vital signs for strategies, and automated wellness-based adjustments.',
    downloads: 4800,
    stars: 350,
    installCommand: '> install the vital-trading skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/vital-trading',
    usageExample: '> check strategy health\n> monitor vital signs\n> auto-adjust by wellness',
    detailedDescription: 'Vital trading health monitoring and wellness system. Monitors strategy vital signs including win rate trends, drawdown progression, and Sharpe ratio degradation, performs regular health checks with automated diagnosis of underperforming strategies, and makes wellness-based parameter adjustments to restore strategy health before significant capital loss.',
  },
  {
    id: 'volty-hyperliquid-agent',
    name: 'volty-hyperliquid-agent',
    author: 'Volty',
    authorHandle: '@volty_ai',
    tag: 'Skill',
    category: 'trading',
    description: 'Volty Hyperliquid volatility agent. Volatility-based trading on Hyperliquid, gamma scalping, and VIX-style crypto volatility index trading.',
    downloads: 5800,
    stars: 420,
    installCommand: '> install the volty-hyperliquid-agent skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/volty-hyperliquid-agent',
    usageExample: '> trade volatility on HL\n> gamma scalp position\n> trade vol index',
    detailedDescription: 'Volty specialized volatility trading agent for Hyperliquid. Trades perpetual futures based on realized vs implied volatility analysis, executes gamma scalping strategies on high-volatility assets, and maintains a VIX-style crypto volatility index for systematic volatility trading and hedging decisions.',
  },
  {
    id: 'vex-trading',
    name: 'vex-trading',
    author: 'Vex',
    authorHandle: '@vex_trading',
    tag: 'Skill',
    category: 'trading',
    description: 'Vex trading system. Fast execution, minimal latency, and streamlined order flow for speed-critical trading strategies.',
    downloads: 5200,
    stars: 380,
    installCommand: '> install the vex-trading skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/vex-trading',
    usageExample: '> execute fast trade\n> minimize latency\n> streamline order flow',
    detailedDescription: 'Vex high-speed trading system optimized for latency-critical strategies. Features minimal round-trip time through direct exchange API connections, streamlined order flow with reduced intermediate processing, and fast execution paths designed for scalping, momentum, and arbitrage strategies where milliseconds matter.',
  },
  {
    id: 'whale-guard',
    name: 'whale-guard',
    author: 'WhaleGuard',
    authorHandle: '@whaleguard',
    tag: 'Skill',
    category: 'trading',
    description: 'WhaleGuard whale monitoring. Large holder movement alerts, whale wallet tracking, and protective positioning before major moves.',
    downloads: 12400,
    stars: 890,
    installCommand: '> install the whale-guard skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/whale-guard',
    usageExample: '> monitor whale wallets\n> alert on large moves\n> position protectively',
    detailedDescription: 'WhaleGuard whale movement monitoring and protection system. Tracks large holder wallets for Bitcoin, Ethereum, and major altcoins with real-time balance monitoring, generates instant alerts when significant transfers or exchange deposits are detected, and suggests protective positioning adjustments before anticipated major market moves.',
  },
  {
    id: 'whale-quad',
    name: 'whale-quad',
    author: 'WhaleQuad',
    authorHandle: '@whalequad',
    tag: 'Skill',
    category: 'trading',
    description: 'WhaleQuad whale intelligence. Four-dimensional whale analysis, holder concentration metrics, and distribution pattern prediction.',
    downloads: 7200,
    stars: 520,
    installCommand: '> install the whale-quad skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/whale-quad',
    usageExample: '> analyze whale 4D data\n> check concentration metrics\n> predict distribution pattern',
    detailedDescription: 'WhaleQuad advanced whale intelligence platform. Analyzes whale behavior across four dimensions: wallet clustering, transaction timing patterns, exchange interaction preferences, and position sizing behavior. Computes holder concentration metrics including Gini coefficient and Lorenz curves, and predicts distribution patterns using historical accumulation and distribution cycle models.',
  },
  {
    id: 'workflow-automation',
    name: 'workflow-automation',
    author: 'WorkflowPro',
    authorHandle: '@workflowpro',
    tag: 'Skill',
    category: 'trading',
    description: 'Workflow automation for trading. Custom trading workflows, trigger-based automation, and conditional action chains for complex strategies.',
    downloads: 8400,
    stars: 600,
    installCommand: '> install the workflow-automation skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/workflow-automation',
    usageExample: '> create trading workflow\n> set trigger automation\n> build conditional chain',
    detailedDescription: 'Trading workflow automation platform for building complex conditional strategies. Create custom workflows with visual drag-and-drop builders, set trigger-based automation including price levels, time conditions, and indicator crosses, and build conditional action chains that execute multi-step strategies with branching logic based on market outcomes.',
  },
  {
    id: 'works-super-agent',
    name: 'works-super-agent',
    author: 'Works',
    authorHandle: '@works_ai',
    tag: 'Skill',
    category: 'trading',
    description: 'Works super trading agent. Master controller for multiple sub-agents, unified strategy orchestration, and collaborative multi-agent trading.',
    downloads: 6200,
    stars: 450,
    installCommand: '> install the works-super-agent skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/works-super-agent',
    usageExample: '> control sub-agents\n> orchestrate unified strategy\n> run multi-agent collaboration',
    detailedDescription: 'Works master super-agent controller for collaborative trading systems. Manages and coordinates multiple specialized sub-agents including scalpers, swing traders, and arbitrageurs, orchestrates unified capital allocation across sub-strategies with dynamic weight adjustment, and enables collaborative multi-agent trading where agents share intelligence and avoid conflicting positions.',
  },
  {
    id: 'xbot-base-agent',
    name: 'xbot-base-agent',
    author: 'XBot',
    authorHandle: '@xbot_ai',
    tag: 'Skill',
    category: 'trading',
    description: 'XBot Base chain agent. Specialized trading on Base L2 with Aerodrome integration, low-cost execution, and Base-native DeFi strategies.',
    downloads: 7800,
    stars: 560,
    installCommand: '> install the xbot-base-agent skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/xbot-base-agent',
    usageExample: '> trade on Base L2\n> integrate with Aerodrome\n> execute Base strategy',
    detailedDescription: 'XBot specialized trading agent for Base Layer 2. Integrates with Aerodrome for concentrated liquidity trading and rewards harvesting, executes trades with minimal gas costs leveraging Base\'s low fee structure, and deploys Base-native DeFi strategies including liquidity provision on Base-exclusive pools and participation in Base ecosystem airdrop farming.',
  },
  {
    id: 'xbot-trading-agent',
    name: 'xbot-trading-agent',
    author: 'XBot',
    authorHandle: '@xbot_ai',
    tag: 'Skill',
    category: 'trading',
    description: 'XBot trading agent. Multi-chain automated trading, cross-venue execution, and AI-powered strategy selection with continuous optimization.',
    downloads: 11200,
    stars: 800,
    installCommand: '> install the xbot-trading-agent skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/xbot-trading-agent',
    usageExample: '> trade multi-chain\n> execute cross-venue\n> optimize AI strategy',
    detailedDescription: 'XBot advanced multi-chain trading agent. Executes automated trading strategies across Ethereum, Solana, Base, and Arbitrum simultaneously, routes orders across CEX and DEX venues for optimal execution, and uses AI-powered strategy selection that continuously learns from market conditions and optimizes parameters through reinforcement learning for maximum risk-adjusted returns.',
  },
];